<label class="switch" title="toggle user status">
    <input type="checkbox" [(ngModel)]="user.is_active" />
    <span (click)="setUserStatus()" class="slider round"></span>
</label>
<div class="switch-label switch-label-active">{{ user.is_active ? 'active' : 'Inactive' }}</div>
